import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'reverse' })
export class ReversePipe implements PipeTransform {
    public transform<T>(originalArray: Array<T>): Array<T> {
        return originalArray.slice().reverse();
    }
}
